import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';

// Warning:
// We need to import and expose these exports from a single place in our app because 'body-scroll-lock' library does side effects on import and
// new <script> content ends up on our website which messes up our CSP rules(allowed scripts/hashes) and the whole app fails to load.
export { disableBodyScroll, enableBodyScroll };

if (import.meta.env.NODE_ENV !== 'test') {
  ReactModal.setAppElement('#root');
}

interface Props extends Omit<ReactModal['props'], 'portalClassName' | 'isOpen' | 'contentLabel'> {
  open: boolean;
  label?: string;
  className?: string;
  modalClassName?: string;
}

export const BaseModal = ({ className, modalClassName, open, label, ...rest }: Props) => {
  const [overlayElement, setOverlayElement] = useState<HTMLElement>();

  useEffect(() => {
    if (!overlayElement) return;

    const modalContentElement = overlayElement.querySelector(`.${modalClassName}`);

    if (!modalContentElement) return;

    if (open) {
      disableBodyScroll(modalContentElement);
    } else {
      enableBodyScroll(modalContentElement);
    }

    return () => modalContentElement && enableBodyScroll(modalContentElement);
  }, [overlayElement, open, modalClassName]);

  return (
    <ReactModal
      portalClassName={className}
      className={modalClassName}
      overlayRef={setOverlayElement}
      contentLabel={label}
      isOpen={open}
      {...rest}
    />
  );
};
